

export default {
    name: 'LeeScrollLyrics',
    inheritAttrs: false,
    data() {
        return {
            progress: 0,
            text: [],//歌词列表
            playStatus: false,//播放状态
            media: null,//声音DOM
            set: null,//定时器
            scrollY: 0,
            mcurtime: 0,
            mduration: 1,
            press: false,//進度條是否按下去
        }
    },
    watch: {
        playStatus: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.set = setInterval(() => {
                        this.action()
                    }, 1)
                } else {
                    clearInterval(this.set)
                }
            }
        },
        press: {
            immediate: true,
            handler(value) {
                if (value) {
                    clearInterval(this.set)
                } else {
                    if (this.playStatus) {
                        this.set = setInterval(() => {
                            this.action()
                        }, 1)
                    } else {
                        if (this.mcurtime != 0) {
                            this.playStatus = true
                            this.media.play()
                        }
                    }
                }
            }
        },
    },
    computed: {
        theStyle() {
            let ww, hh
            if (this.width === 'fit') {
                ww = '100%'
            } else {
                ww = this.width + 'px'

            }
            if (this.height === 'fit') {
                hh = '100%'
            } else {
                hh = this.height + 'px'
            }

            return 'width:' + ww + ';height:' + hh + ';--activeColor:' + this.activeColor
        }
    },
    mounted() {
        this.media = this.$refs.media
        let _this = this
        fetch(this.lyrics)
            .then(function (response) {
                return response.text();
            })
            .then(function (myJson) {
                let line = myJson.split('\n');
                line.forEach((el, xh) => {
                    let rs = el.split(']');
                    if (rs[1] == undefined) {
                        rs[1] = "";
                    }
                    _this.text.push({xh: xh + 1, time: rs[0] + ']', text: rs[1]});
                })

            });
        //这个是为了滑动条释放
        document.addEventListener('mouseup', () => {
            if(this.mcurtime!=(this.progress / 100) * this.mduration){
                this.press=false
                this.media.currentTime = (this.progress / 100) * this.mduration//是为了防止没有拖动滑块
            }
        })
    },
    methods: {
        action() {
            this.mcurtime = this.media.currentTime
            this.mduration = this.media.duration
            this.progress = (this.mcurtime / this.mduration) * 100
            this.text.forEach((el) => {
                this.$set(el, 'cur', false)
            })
            let fi = this.text.filter((el) => {
                let min = Number(el.time.substr(1, 2));
                let sec = Number(el.time.substring(4, el.time.length - 1));
                let lastSec = min * 60 + sec;
                let diff = this.media.currentTime;
                return diff - lastSec >= 0
            })
            this.$set(fi[fi.length - 1], 'cur', true)
            let midxh = this.height * 0.8 / this.lineHeight//这个是中间序号，这样滚动加亮在整体中间
            midxh = Math.floor(midxh / 2)
            if (fi[fi.length - 1].xh > midxh && this.scrollY < midxh * this.lineHeight) {
                this.scrollY = -this.lineHeight * (fi[fi.length - 1].xh - midxh);
            } else {
                this.scrollY = 0
            }
        },
        bf() {
            this.media.play()
            this.playStatus = true
        },
        zt() {
            this.media.pause()
            this.playStatus = false
        },
    },
    props: {
        width: [String, Number],
        height: [String, Number],
        audio: {
            type: String,
            default: '/scrolllyrics/lxl.mp3'
        },
        lyrics: {
            type: String,
            default: '/scrolllyrics/lxl.txt'
        },
        bgPic: {
            type: String,
            default: ''
        },
        bgColor: {
            type: String,
            default: '#46bd87'
        },
        color: {
            type: String,
            default: '#000'
        },
        activeColor: {
            type: String,
            default: '#46bd87'
        },
        lineHeight: {
            type: Number,
            default: 36
        },
    }
}
